import React from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import { Reception } from 'api';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {header} from "constants/table";
import moment from 'moment';
import { TimKiemYeuCau } from 'modules/reception-periodical/form-timkiem';
import DataTable from 'components/data-table';
import { RowItemYeuCau } from 'modules/reception-periodical/datatable/list';
import {MasterLayout} from 'layout';
import { DetailReception } from 'modules/reception-periodical/popup-detail';
import {FormSort} from 'modules/reception/form-sort';
class DanhSachYeuCau extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      sortBy: 'ngayLapDonGapLanhDaoTmp,desc',
      trangThaiList: [],
      search: false,
      tableLoading: false,
      searchLoading: false,
      tuKhoa: '',
      trangThai : '',
      nguonDon : '',
      phanLoai : '',
      tuNgay : '',
      denNgay : '',
      detailPopupStatus: false,
      detailPopupInfo: {noiDung: ''}
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
    this.state.advanceSearch = data.advanceSearch || false;
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.tuKhoa = data.tuKhoa || '';
    if (this.state.advanceSearch) {
      this.state.trangThai = data.trangThai || '';
      this.state.nguonDon = data.nguonDon || '';
      this.state.phanLoai = data.phanLoai || '';
      this.state.tuNgay =  data.tuNgay ? new Date(data.tuNgay) : '';
      this.state.denNgay = data.denNgay ? new Date(data.denNgay) : '';
    }
    this.setState({...this.state});
    this.getListData();
    this.getTrangThai();
  }

  openSearchForm() {
    this.setState({advanceSearch: true});
    let data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
    data.advanceSearch = true;
    localStorage.setItem('dsycData', JSON.stringify(data));
  }

  closeSearchForm() {
    this.setState({advanceSearch: false});
    let data = localStorage.getItem('dsycData') ? JSON.parse(localStorage.getItem('dsycData')) : {};
    data.advanceSearch = false;
    localStorage.setItem('dsycData', JSON.stringify(data));
  }

  handleChange(name, e) {
    this.setState({
      [e.target.name]: e.target.value
    })
    if (name === 'sortBy') {
      this.handleSort(e.target.value);
    }
  }

  handleSort(sortBy) {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: sortBy
    };
    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });
    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa;
    }

    if (this.state.advanceSearch) {
      if (this.state.trangThai) {
        params.trangThai = this.state.trangThai;
      }

      if (this.state.phanLoai) {
        params.phanLoai = this.state.phanLoai;
      }

      if (this.state.nguonDon) {
        params.nguonDon = this.state.nguonDon;
      }

      if (this.state.tuNgay) {
        params.tuNgay = moment(new Date(this.state.tuNgay)).add(7, 'hours').toISOString();
      }

      if (this.state.denNgay) {
        params.denNgay = moment(new Date(this.state.denNgay)).add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('dsycData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    Reception.actions.getDanhSachYeuCau.request(null, params).then(res => {
      let Data = [];
      if (res.data._embedded) {
        Data = res.data._embedded.dons;
        this.state.pageData = res.data.page;
      } else {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listTCDYC', data: Data})
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
    }).catch(err => {
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handleSearch(searchData, e) {
    // Dung ung dung neu ngay nhap khong hop le
    if ([searchData.tuNgay, searchData.denNgay].indexOf('INVALID') != -1) {
      return;
    }
    this.state.search = true;
    let newData = {
      ...this.state,
      ...searchData
    }
    this.state = newData;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});

    this.getListData();
  }

  getListData() {

    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: this.state.sortBy
    }

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true
    });

    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa;
    }

    if (this.state.advanceSearch) {
      if (this.state.trangThai) {
        params.trangThai = this.state.trangThai;
      }

      if (this.state.phanLoai) {
        params.phanLoai = this.state.phanLoai;
      }

      if (this.state.nguonDon) {
        params.nguonDon = this.state.nguonDon;
      }

      if (this.state.tuNgay) {
        params.tuNgay = moment(new Date(this.state.tuNgay)).add(7, 'hours').toISOString();
      }

      if (this.state.denNgay) {
        params.denNgay = moment(new Date(this.state.denNgay)).add(7, 'hours').toISOString();
      }
    }
    localStorage.setItem('dsycData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    Reception.actions.getDanhSachYeuCau.request(null, params).then(res => {
      let Data = [];
      if (res.data._embedded) {
        Data = res.data._embedded.dons;
        this.state.pageData = res.data.page;
      } else {
        this.state.pageData = {
          number: 0,
          size: 10,
          totalElements: 0
        };
      }
      this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listTCDYC', data: Data})

      this.state.tableLoading = false;
      this.state.searchLoading = false;
      this.state.searching = false;
      this.state.search = false;
      this.setState({...this.state});
    }).catch(err => {
      this.state.tableLoading = false;
      this.state.searchLoading = false;
      this.state.searching = false;
      this.state.search = false;
      this.setState({...this.state});
    });
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
    this.getTrangThai();
  }

  handleDelete(sID) {
    this.props.Reception.deleteTiepCongDanDinhKy({id: sID}).then(res => {
      this.props.dispatch({
        type: 'DELETE_ITEM_DATALIST',
        key: 'listTCDYC',
        idKey: 'soTiepCongDanId',
        id: sID
      });
      this.getListData();
      Toastr(msg.dTCDTX,'success');
    }).catch(err => {
      let Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
      Data.map(item => {
        Toastr(item.description, 'error');
      })
    });
  }

  getTrangThai() {
    Reception.actions.getTrangThaiYeuCau.request().then(res => {
      if (res.data) {
        this.setState({
          trangThaiList: res.data
        });
      } else {
        this.setState({
          trangThaiList: []
        });
      }
    });
  }

  handleClickDetail(item, status) {
    if (status) {
      Reception.actions.getDonInfo.request({ id: item.donId }).then(res => {
        if (res.data) {
          this.setState({
            detailPopupInfo: {...item, ...res.data}
          });
        }
      });
    }
    this.setState({
      detailPopupStatus: status
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <DetailReception
            noiDung = {this.state.detailPopupInfo.noiDung}
            item={this.state.detailPopupInfo}
            isOpen={this.state.detailPopupStatus}
            onClose={this.handleClickDetail.bind(this, {}, false)}
          />
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Danh sách đăng ký gặp lãnh đạo</p>
            </div>
          </div>
          <div className="bottom-content">
            <div className={ this.state.advanceSearch ? 'search-container super-search' : 'search-container' }>
              <TimKiemYeuCau advanceSearch={this.state.advanceSearch} onCancel={ this.closeSearchForm.bind(this) } handleSearch={ this.handleSearch.bind(this) } disabled={ this.state.searching } search={ this.state.search } />
              <Link className="rearch-text"  onClick={this.openSearchForm.bind(this)}><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <FormSort
              type='dangKiGapLanhDao'
              pageDetail={this.state.pageData}
              selectedValue={this.state.sortBy}
              onChange={ this.handleChange.bind(this, 'sortBy') }
            />
            <DataTable
              header = {header.receptionPeriodical.listYeuCau}
              dataList = {this.state.data}
              exporttext ="Xuất sổ đăng ký gặp lãnh đạo"
              pageData={this.state.pageData}
              sortBy={this.state.sortBy}
              parent= {this}
              type="DINH_KY"
              typeExport="DS_YEU_CAU"
              search= {this.state.search}
              tableLoading = {this.state.tableLoading}
            >
              <RowItemYeuCau trangThaiList={this.state.trangThaiList} onClickDetail={this.handleClickDetail.bind(this)}/>
            </DataTable>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

DanhSachYeuCau.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listTCDYC
  };
}

export default connect(bindStateToProps)(DanhSachYeuCau);



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/list-reception-periodical/DanhSachYeuCau.jsx